<template>
  <el-container>
    <div class="h-background">
      <img v-if="theme && theme.bgImgFile" :src="theme.bgImgFile" width="100%" height="100%" alt=""  />
    </div>
    <div class="h-main">
      <div class="h-load-img">
        <img v-if="theme" :src="theme.loadingImgFile" />
      </div>
      <div class="h-load-text">正在加载，请稍后…</div>
    </div>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex"
// import cfg from "@/common/cfg"
import api from "@/common/api"
export default {
    computed: {
        ...mapGetters(["token", "theme"])
    },
    data() {
      return {
        imgSrc: require('../assets/bg.png'),
      }
    },
    async mounted() {
        let _this = this;
        try {
            const success = await _this.login();
            if (success) {
                const ps = await api.getPermission();
                if (!ps.length) {
                    _this.$utils.goErr(cfg.errs.NeedPromission);
                    throw new Error("抱歉，您没有权限访问此系统！");
                }
                const url = `${location.origin}/#/welcome`
                if (location.href != url) {
                    location.replace(url);
                }
                _this.$store.dispatch("init")
                _this.$router.replace({ name: "leisure" })
            }
        } catch (err) {
            if (err) {
                _this.$message.error(err.message || err);
            }
        }
    },
    methods: {
        async login() {
            let _this = this
            if (_this.token) {
                return true
            }
            // 授权码换Token
            const callbackUrl = location.href.split("?")[0];
            if (callbackUrl === cfg.oauth.callbackUrl) {
                if (location.search.indexOf("code") >= 0) {
                    const code = /\?code=(.*)[&$]?/.exec(location.search)[1];
                    const res = await api.getToken(code, encodeURI(callbackUrl))
                    _this.$utils.saveToken(res)
                    return true
                }
            }
            // CA LOGIN
            const uri = `${cfg.oauth.server}/oauth/authorize?response_type=code&client_id=${cfg.oauth.client}&redirect_uri=${encodeURI(cfg.oauth.callbackUrl)}`
            location.replace(uri)
            return false
        },
    }
};
</script>

<style scoped>
  .h-background {
    left: 0;
    top: 0;
    width:100%;
    height:100%;  /**宽高100%是为了图片铺满屏幕 */
    z-index:-1;
    position: absolute;
  }
  .h-main{
    display:flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    margin-top:-100px;
  }
  .h-load-img{
    margin: 0 auto;
    display: flex;
    justify-content: center;
    width: 175px;
    height: 175px;
  }
  .h-load-img img{
    width: 100%;
    height: 100%;
  }
  .h-load-text{
    margin-top: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #362108;
  }
.title {
    display: flex;
    justify-content: center;
    color: #673c63;
    align-items: center;
    font-size: 3rem;
}

.logo {
    height: 5rem;
    margin-right: 1rem;
}

.box {
    color: #673c63;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
}

.body {
    height: 100%;
    background-color: #eeeeee;
}
</style>
